export function getArrayWithIndexMovedToStart<T>(arr: T[], index: number): T[] {
  if (index < 0 || index >= arr.length) {
    return arr;
  }
  const element = arr[index];
  const newArr = [...arr];
  newArr.splice(index, 1);
  return element !== undefined ? [element, ...newArr] : newArr;
}
